module.exports = __webpack_public_path__ + "images/emoji/confused.86a1547fb9615cede6a9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/confused.png
// module id = s6/D
// module chunks = 13